import React from 'react';
import TableRow from "@mui/material/TableRow";
import Skeleton from '@mui/material/Skeleton';
import TableCell from "@mui/material/TableCell";
import EditIcon from "@mui/icons-material/Edit";
import {useTranslation} from "react-i18next";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Price from "../../../../data/Price/Price";
import Button from "../../../../inputs/Button";

const Row = ({seat, loading, onSelected, vat}) => {
    const {t} = useTranslation();
    const displaySeat = (!loading && seat);

    return (
        <TableRow>
            <TableCell>
                {!displaySeat && <Skeleton variant="circular" width={40} height={40}/>}
                {(displaySeat && seat.Visible === 'Y') && <VisibilityIcon/>}
                {(displaySeat && seat.Visible === 'N') && <VisibilityOffIcon/>}
            </TableCell>
            <TableCell>
                {!displaySeat && <Skeleton/>}
                {(displaySeat) && <span>{seat.Seat_Name}</span>}
            </TableCell>
            <TableCell>
                {!displaySeat && <Skeleton/>}
                {(displaySeat) && <span>{seat.Description}</span>}
            </TableCell>
            <TableCell>
                {!displaySeat && <Skeleton/>}
                {(displaySeat) &&
                <span>{t('seat_capacity_summary', {count: seat.Count, capacity: seat.Capacity})}</span>}
            </TableCell>
            <TableCell>
                {!displaySeat && <Skeleton/>}
                {(displaySeat) && <span>{
                    <Price
	                    value={parseFloat(seat.Price.value)}
	                    currency={seat.Currency__}
	                    priceIncludeVat={!!seat.Price_Flags.vat_included}
	                    inclVat={true}
	                    vat={vat}
                    />
                }</span>}
            </TableCell>
            <TableCell>
                {!displaySeat && <Skeleton/>}
                {(displaySeat) && <span>{seat.Currency__}</span>}
            </TableCell>
            <TableCell align="right">
                {!displaySeat && <Skeleton/>}
                {(displaySeat) && <Button
                    variant="contained"
                    color="primary"
                    onClick={() => onSelected(seat)}
                    startIcon={<EditIcon/>}
                >
                    {t('edit_btn')}
                </Button>}

            </TableCell>
        </TableRow>
    );
};

export default Row;
